import { createSlice } from "@reduxjs/toolkit";

export const userRoutesSlice = createSlice({
  name: "userRoutes",
  initialState: {
    userRoutes: [],
  },
  reducers: {
    setUserRoutes: (state, action) => {
      state.userRoutes = action.payload;
    },
  },
});

export const { setUserRoutes } = userRoutesSlice.actions;

export default userRoutesSlice.reducer;
